(function () {
    'use strict';

    angular
        .module('financial')
        .controller('AtmReportController', AtmReportController);

    AtmReportController.$inject = ['SellerService', 'AtmService'];


    function AtmReportController(SellerService, AtmService) {
        var vm              = this;
        vm.getSellers       = getSellers;
        vm.sellerSelected   = '';
        vm.getByFilter      = getByFilter;
        vm.pageChanged      = pageChanged;
        vm.setPage          = setPage;
        vm.page             = 1;
        vm.flag             = false;
        vm.noResultMessage  = '';
        vm.to               = null;
        
        function getSellers () {
            SellerService.getStaff().then(function(response) {
                vm.sellers = response.data;
            });
        }

        function getByFilter () {
            let query = {};

            if (vm.sellerSelected != '') {
                query['seller'] = vm.sellerSelected;
            }

            if(vm.page !== null) {
                query['page'] = vm.page;
            }

            AtmService.getByFilter(query).then(function(response) {
                vm.atms = response.data.data;
                if(vm.atms.length == 0){
                    vm.noResultMessage = 'Sorry, no results were found!';
                    vm.flag = false;
                } else {
                    vm.noResultMessage = '';
                    vm.flag = true;
                }
                vm.totalItems = response.data.total;
                vm.to         = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            });
        }

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function activate () {
            vm.getSellers();
            vm.getByFilter();
        }

        activate();
    }

})();